import { render, staticRenderFns } from "./IgmpRouterStatic.vue?vue&type=template&id=6c6d0530&"
import script from "./IgmpRouterStatic.vue?vue&type=script&lang=js&"
export * from "./IgmpRouterStatic.vue?vue&type=script&lang=js&"
import style0 from "./IgmpRouterStatic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports